var map = {
	"./agromat.jpg": "06a8",
	"./agrosem.jpg": "e2ff",
	"./arcmet.jpg": "7d9d",
	"./budpostach.jpg": "ad51",
	"./centra.jpg": "849f",
	"./eva.jpg": "5721",
	"./gs.jpg": "6425",
	"./hc.jpg": "f656",
	"./metinvest.jpg": "f468",
	"./mhp.jpg": "87a9",
	"./rud.jpg": "8b1b",
	"./shedro.jpg": "0886",
	"./sirius.jpg": "b264",
	"./terra.jpg": "7398",
	"./tpk.jpg": "7034",
	"./ufc.jpg": "b1e3",
	"./varus.jpg": "03ee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31d0";